<template>
    <div class="tyn-root">
        <Header></Header>
        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section pt-0 pb-0">
                    <div class="modern-header">
                        <div class="container">
                            <div class="header-content">
                                <div class="title-section">
                                    <h1 class="modern-title">Dashboard de Processos</h1>
                                    <p class="modern-subtitle">Acompanhe os KPIs e métricas de desempenho</p>
                                </div>
                            </div>
                        </div>
                    </div><!-- modern-header -->

                    <div class="dashboard-container">
                        <div class="container-fluid">
                            <!-- 3.1. VISÃO GERAL - Cards de KPI -->
                            <section class="dashboard-section">
                                <h2 class="section-title">Visão Geral</h2>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="kpi-cards-grid">
                                            <div class="kpi-card"
                                                 @click="abreModalProcessos()">
                                                <div class="kpi-icon" style="background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);">
                                                    <i class="fas fa-folder-open"></i>
                                                </div>
                                                <div class="kpi-content">
                                                    <div class="kpi-label">Total de Processos </div>
                                                    <div class="kpi-value">
                                                        <template v-if="kpiData.totalProcessos != null">
                                                            {{ kpiData.totalProcessos }}
                                                        </template>
                                                        <div class="spinner-border" role="status" v-else>
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="kpi-content">
                                                    <div class="kpi-label">Total de Processos Ativos</div>
                                                    <div class="kpi-value">
                                                        <template v-if="kpiData.totalProcessosAtivos != null">
                                                            {{ kpiData.totalProcessosAtivos }}
                                                        </template>
                                                        <div class="spinner-border" role="status" v-else>
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="kpi-content">
                                                    <div class="kpi-label">Total de Processos Finalizados</div>
                                                    <div class="kpi-value">
                                                        <template v-if="kpiData.totalProcessosFinalizados != null">
                                                            {{ kpiData.totalProcessosFinalizados }}
                                                        </template>
                                                        <div class="spinner-border" role="status" v-else>
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>

                                            <div class="kpi-card kpi-card-alert" @click="abreModalProcessosAtrasados()">
                                                <div class="kpi-icon" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);">
                                                    <i class="fas fa-exclamation-triangle"></i>
                                                </div>
                                                <div class="kpi-content">
                                                    <div class="kpi-label">Processos Atrasados</div>
                                                    <div class="kpi-value">
                                                        <template v-if="kpiData.processosAtrasados != null">
                                                            {{ kpiData.processosAtrasados }}
                                                        </template>
                                                        <div class="spinner-border" role="status" v-else>
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="kpi-card"
                                                 data-bs-custom-class="custom-popover"
                                                 data-bs-toggle="popover"
                                                 data-bs-placement="right"
                                                 :data-bs-content="getDataBsTMC()">
                                                <div class="kpi-icon" style="background: linear-gradient(135deg, #10b981 0%, #059669 100%);">
                                                    <i class="fas fa-clock"></i>
                                                </div>
                                                <div class="kpi-content">
                                                    <div class="kpi-label">Tempo Médio de Ciclo (TMC)</div>
                                                    <div class="kpi-value">
                                                        <template v-if="kpiData.tempoMedioCiclo != null">
                                                            {{ kpiData.tempoMedioCiclo }} dias
                                                        </template>
                                                        <div class="spinner-border" role="status" v-else>
                                                            <span class="visually-hidden">Loading...</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <!-- Gráfico de Medidor (Gauge Chart) -->
                                        <div class="chart-container">
                                            <div class="chart-card">
                                                <h3 class="chart-title">Taxa de Cumprimento de Prazo (Geral)</h3>
                                                <template v-if="gaugeChartData != null">
                                                    <div class="gauge-chart-wrapper my-2">
                                                        <GaugeChart :chart-data="gaugeChartData" options="gaugeChartOptions" />
                                                        <div class="gauge-value">
                                                            <div class="gauge-value-number">{{gaugeChartData.percentual}}%</div>
                                                            <div class="gauge-value-label">Cumprimento</div>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div class="spinner-border" role="status" v-else>
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                </div>



                            </section>

                            <!-- 3.2. RISCO E STATUS -->
                            <section class="dashboard-section">
                                <h2 class="section-title">Risco e Status</h2>
                                <!-- Lista de Processos Críticos -->
                                <div class="chart-card mb-2">
                                    <h3 class="chart-title">Artefatos Críticos de Processos (Atrasados ou Em Risco)</h3>
                                    <div class="table-responsive table-responsive-processos-criticos">
                                        <table class="processos-criticos-table">
                                            <thead>
                                                <tr>
                                                    <th>Processo</th>
                                                    <th>Artefato</th>
                                                    <th>Etapa Atual</th>
                                                    <th>Status</th>
                                                    <th>Responsável</th>
                                                    <th>Dias de Atraso</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-if="processosCriticos != null">
                                                    <tr v-for="(processo,index) in processosCriticos" :key="index">
                                                        <td>{{ processo.nome }}</td>
                                                        <td>{{ processo.nmModelo }}</td>
                                                        <td>{{ processo.etapaAtual }}</td>
                                                        <td>
                                                            <span :class="['status-badge', getStatusClass(processo.status)]">
                                                                {{ processo.status }}
                                                            </span>
                                                        </td>
                                                        <td>{{ processo.responsavel }}</td>
                                                        <td>
                                                            <span v-if="processo.diasAtraso > 0" class="dias-atraso">
                                                                {{ processo.diasAtraso }} dias
                                                            </span>
                                                            <span v-else>-</span>
                                                        </td>
                                                    </tr>
                                                    <tr v-if="processosCriticos.length === 0">
                                                        <td colspan="6" class="empty-state">
                                                            <div class="empty-content">
                                                                <h5 class="empty-title">Nenhum processo encontrado</h5>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>
                                                <template v-else>
                                                    <tr class="text-center">
                                                        <td colspan="6">
                                                            <div class="spinner-border" role="status">
                                                                <span class="visually-hidden">Loading...</span>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                </template>



                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="charts-grid">
                                    <!-- Gráfico de Rosca (Donut Chart) de Status do Processo -->
                                    <div class="chart-card">
                                        <h3 class="chart-title">Distribuição por Status do Processo</h3>
                                        <div class="donut-chart-wrapper">
                                            <DonutChart :chart-data="donutChartData" :options="donutChartOptions" />
                                        </div>
                                    </div>

                                    <!-- Gráfico de Barras Empilhadas de Risco por Etapa -->
                                    <div class="chart-card">
                                        <h3 class="chart-title">Risco por Etapa</h3>
                                        <BarChart :chart-data="riscoEtapaChartData" :options="riscoEtapaChartOptions" />
                                    </div>
                                </div>


                            </section>

                            <!-- 3.3. EFICIÊNCIA E DESEMPENHO -->
                            <section class="dashboard-section">
                                <h2 class="section-title">Eficiência e Desempenho</h2>
                                <div class="charts-grid">
                                    <!-- Gráfico de Barras de Tempo Médio por Etapa/Artefato -->
                                    <div class="chart-card">
                                        <h3 class="chart-title">Tempo Médio por Etapa/Artefato</h3>
                                        <BarChart :chart-data="tempoMedioEtapaChartData" :options="tempoMedioEtapaChartOptions" />
                                    </div>

                                    <!-- Gráfico de Barras Empilhadas de Carga de Trabalho por Responsável -->
                                    <div class="chart-card">
                                        <h3 class="chart-title">Carga de Trabalho por Responsável</h3>
                                        <BarChart :chart-data="cargaTrabalhoChartData" :options="cargaTrabalhoChartOptions" />
                                    </div>
                                </div>

                                <div class="charts-grid">
                                    <!-- Gráfico de Barras de Índice de Retrabalho -->
                                    <div class="chart-card">
                                        <h3 class="chart-title">Índice de Retrabalho por Artefato</h3>
                                        <BarChart :chart-data="retrabalhoChartData" :options="retrabalhoChartOptions" />
                                    </div>

                                    <!-- Gráfico de Linha de Tendência do TMC -->
                                    <div class="chart-card">
                                        <h3 class="chart-title">Tendência do Tempo Médio de Ciclo (TMC)</h3>
                                        <LineChart :chart-data="tmcTendenciaChartData" :options="tmcTendenciaChartOptions" />
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div><!-- tyn-section -->
            </div><!-- tyn-main -->
        </div><!-- tyn-content -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>

        <!-- MODAL PROCESSOS ATIVOS -->
        <div class="modal fade modern-modal" id="ModalProcessosAtivos" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <div class="kpi-icon" style="background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);">
                                <i class="fas fa-folder-open"></i>
                            </div>
                        </div>
                        <div class="header-text">
                            <h2>Processos Ativos</h2>
                            <p>Lista dos processos ativos.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="table-responsive table-responsive-processos-criticos">
                            <table class="processos-criticos-table">
                                <thead>
                                    <tr>
                                        <th>Número</th>
                                        <th>Nome</th>
                                        <th>Proprietário</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="lstProcessos != null">
                                        <tr v-for="(processo,index) in lstProcessos" :key="index">
                                            <td>{{ processo.cdProcesso }}</td>
                                            <td>{{ processo.dsNomeProcesso }}</td>
                                            <td>{{ processo.dsLoginProprietarioProcesso }}</td>
                                            <td>
                                                <span :class="['status-badge', (processo.flFinalizado? 'status-badge--ativo':'status-badge--ativo')]">
                                                    {{ (processo.flFinalizado?'Finalizado':'Ativo') }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="lstProcessos.length === 0">
                                            <td colspan="4" class="empty-state">
                                                <div class="empty-content">
                                                    <h5 class="empty-title">Nenhum processo encontrado</h5>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr class="text-center">
                                            <td colspan="6">
                                                <div class="spinner-border" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>



                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="modern-btn modern-btn-secondary d-none"
                                data-bs-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- MODAL PROCESSOS ATRASADOS -->
        <div class="modal fade modern-modal" id="ModalProcessosAtrasados" tabindex="-1" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg modal-modern">
                <div class="modal-content modal-modern-content border-0">
                    <button type="button" class="btn btn-md btn-icon btn-pill btn-white shadow position-absolute top-0 end-0 mt-n3 me-n3"
                            data-bs-dismiss="modal" aria-label="Close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                        </svg>
                    </button>

                    <div class="modal-modern-header">
                        <div class="header-icon">
                            <div class="kpi-icon" style="background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);">
                                <i class="fas fa-exclamation-triangle"></i>
                            </div>
                        </div>
                        <div class="header-text">
                            <h2>Processos Atrasados</h2>
                            <p>Lista dos processos atrasados.</p>
                        </div>
                    </div>

                    <div class="modal-modern-body">
                        <div class="table-responsive table-responsive-processos-criticos">
                            <table class="processos-criticos-table">
                                <thead>
                                    <tr>
                                        <th>Número</th>
                                        <th>Nome</th>
                                        <th>Proprietário</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <template v-if="lstProcessos != null">
                                        <tr v-for="(processo,index) in lstProcessosAtrasados" :key="index">
                                            <td>{{ processo.cdProcesso }}</td>
                                            <td>{{ processo.dsNomeProcesso }}</td>
                                            <td>{{ processo.dsLoginProprietarioProcesso }}</td>
                                            <td>
                                                <span :class="['status-badge', (processo.flFinalizado? 'status-badge--ativo':'status-badge--ativo')]">
                                                    {{ (processo.flFinalizado?'Finalizado':'Ativo') }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr v-if="lstProcessos.length === 0">
                                            <td colspan="4" class="empty-state">
                                                <div class="empty-content">
                                                    <h5 class="empty-title">Nenhum processo encontrado</h5>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr class="text-center">
                                            <td colspan="6">
                                                <div class="spinner-border" role="status">
                                                    <span class="visually-hidden">Loading...</span>
                                                </div>
                                            </td>
                                        </tr>
                                    </template>



                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="modal-modern-footer">
                        <button type="button"
                                class="modern-btn modern-btn-secondary d-none"
                                data-bs-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div> <!-- tyn-root-->
</template>

<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import axios from 'axios'
    import { urlApi, avisoToast } from '@/config/global'

    import { Doughnut, Bar, Line } from 'vue-chartjs'
    import {
        Chart as ChartJS,
        ArcElement,
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        BarElement,
        Title,
        Tooltip,
        Legend,
        Filler
    } from 'chart.js'

    // Registrar componentes do Chart.js
    ChartJS.register(
        ArcElement,
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        BarElement,
        Title,
        Tooltip,
        Legend,
        Filler
    )

    // Componente Gauge Chart (usando Doughnut com configuração especial para simular medidor)
    const GaugeChart = {
        extends: Doughnut,
        props: ['chartData', 'chartOptions'],
        mounted() {
            //this.renderChart(this.chartData, this.chartOptions)
        },
        watch: {
            chartData: {
                handler() {
                    //this.$data._chart.update()
                },
                deep: true
            }
        }
    }

    // Componente Donut Chart
    const DonutChart = {
        extends: Doughnut,
        props: ['chartData', 'chartOptions'],
        mounted() {
            //this.renderChart(this.chartData, this.chartOptions)
        },
        watch: {
            chartData: {
                handler() {
                    //this.$data._chart.update()
                },
                deep: true
            }
        }
    }

    // Componente Bar Chart
    const BarChart = {
        extends: Bar,
        props: ['chartData', 'chartOptions'],
        mounted() {
            //this.renderChart(this.chartData, this.chartOptions)
        },
        watch: {
            chartData: {
                handler() {
                    //this.$data._chart.update()
                },
                deep: true
            }
        }
    }

    // Componente Line Chart
    const LineChart = {
        extends: Line,
        props: ['chartData', 'chartOptions'],
        mounted() {
            //this.renderChart(this.chartData, this.chartOptions)
        },
        watch: {
            chartData: {
                handler() {
                    //this.$data._chart.update()
                },
                deep: true
            }
        }
    }

    export default {
        name: 'DashboardProcesso',
        components: {
            Header,
            Modais,
            GaugeChart,
            DonutChart,
            BarChart,
            LineChart
        },
        data: function () {
            return {
                bsModalProcessosAtivos: null,
                bsModalProcessosAtrasados: null,

                lstProcessos: null,
                lstProcessosAtrasados: null,
                // Dados fixos para KPIs
                kpiData: {
                    totalProcessos: null,
                    totalProcessosAtivos: null,
                    totalProcessosFinalizados: null,
                    processosAtrasados: null,
                    tempoMedioCiclo: null
                },

                // Dados fixos para Processos Críticos
                processosCriticos: [],

                // Configuração do Gauge Chart (Taxa de Cumprimento)
                gaugeChartData: null,
                gaugeChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: '75%',
                    circumference: 180,
                    rotation: -90,
                    plugins: {
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    const label = context.label || ''
                                    const value = context.parsed || 0
                                    return label + ': ' + value + '%'
                                }
                            }
                        }
                    }
                },

                // Configuração do Donut Chart (Status do Processo)
                donutChartData: {
                    labels: ['Em Andamento', 'Em Revisão', 'Aguardando Aprovação', 'Aguardando Assinatura', 'Concluído'],
                    datasets: [{
                        data: [],
                        backgroundColor: [
                            '#3b82f6',
                            '#f59e0b',
                            '#8b5cf6',
                            '#ec4899',
                            '#10b981'
                        ],
                        borderWidth: 2,
                        borderColor: '#ffffff'
                    }]
                },
                donutChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'bottom',
                            labels: {
                                padding: 15,
                                usePointStyle: true
                            }
                        },
                        tooltip: {
                            callbacks: {
                                label: function(context) {
                                    const label = context.label || ''
                                    const value = context.parsed || 0
                                    const total = context.dataset.data.reduce((a, b) => a + b, 0)
                                    const percentage = ((value / total) * 100).toFixed(1)
                                    return label + ': ' + value + ' (' + percentage + '%)'
                                }
                            }
                        }
                    }
                },

                // Configuração do Gráfico de Barras Empilhadas de Risco por Etapa
                riscoEtapaChartData: {
                    labels: ['Elaboração', 'Revisão', 'Aprovação', 'Assinatura', 'Publicação'],
                    datasets: [
                        {
                            label: 'No Prazo',
                            data: [],
                            backgroundColor: '#10b981'
                        },
                        {
                            label: 'Em Risco',
                            data: [],
                            backgroundColor: '#f59e0b'
                        },
                        {
                            label: 'Atrasado',
                            data: [],
                            backgroundColor: '#ef4444'
                        }
                    ]
                },
                riscoEtapaChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            stacked: true,
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            stacked: true,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 5
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                            labels: {
                                usePointStyle: true,
                                padding: 15
                            }
                        }
                    }
                },

                // Configuração do Gráfico de Barras de Tempo Médio por Etapa
                tempoMedioEtapaChartData: {
                    labels: ['Elaboração', 'Revisão', 'Aprovação', 'Assinatura', 'Publicação'],
                    datasets: [{
                        label: 'Tempo Médio (dias)',
                        data: [],
                        backgroundColor: '#3b82f6'
                    }]
                },
                tempoMedioEtapaChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            ticks: {
                                stepSize: 2
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        }
                    }
                },

                // Configuração do Gráfico de Barras Empilhadas de Carga de Trabalho
                cargaTrabalhoChartData: {
                    labels: [],
                    datasets: [
                        {
                            label: 'No Prazo',
                            data: [],
                            backgroundColor: '#10b981'
                        },
                        {
                            label: 'Atrasado',
                            data: [],
                            backgroundColor: '#ef4444'
                        }
                    ]
                },
                cargaTrabalhoChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: {
                            stacked: true,
                            grid: {
                                display: false
                            }
                        },
                        y: {
                            stacked: true,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 2
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                            labels: {
                                usePointStyle: true,
                                padding: 15
                            }
                        }
                    }
                },

                // Configuração do Gráfico de Barras de Índice de Retrabalho
                retrabalhoChartData: {
                    labels: [],
                    datasets: [{
                        label: 'Índice de Retrabalho (%)',
                        data: [],
                        backgroundColor: '#8b5cf6'
                    }]
                },
                retrabalhoChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: true,
                            max: 30,
                            ticks: {
                                stepSize: 5,
                                callback: function(value) {
                                    return value + '%'
                                }
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            display: false
                        }
                    }
                },

                // Configuração do Gráfico de Linha de Tendência do TMC
                tmcTendenciaChartData: {
                    labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    datasets: [{
                        label: 'Tempo Médio de Ciclo (dias)',
                        data: [],
                        borderColor: '#3b82f6',
                        backgroundColor: 'rgba(59, 130, 246, 0.1)',
                        fill: true,
                        tension: 0.4,
                        pointRadius: 5,
                        pointHoverRadius: 7
                    }]
                },
                tmcTendenciaChartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        y: {
                            beginAtZero: false,
                            min: 15,
                            max: 30,
                            ticks: {
                                stepSize: 2
                            }
                        }
                    },
                    plugins: {
                        legend: {
                            position: 'top',
                            labels: {
                                usePointStyle: true,
                                padding: 15
                            }
                        }
                    }
                }
            }
        },
        methods: {
            getStatusClass(status) {
                if (status === 'Atrasado') return 'status-badge--inativo'
                if (status === 'Em Risco') return 'status-badge--risco'
                return 'status-badge--ativo'
            },
            load() {
                let $this = this;
                axios.post(`${urlApi}/Log/Registrar`, { cdTipoLog: 'PI_CON_DASH' }).catch(() => { })

                $this.getTotalProcessosAtivos();
                $this.getProcessosAtrasados();
                $this.getTempoMedioCicloTotal();
                $this.getTaxaCumprimentoPrazo();
                $this.getDistribuicaoPorStatusProcesso();
                $this.getProcessosCriticos();
                $this.getRiscoEtapa();
                $this.getTempoMedioEtapa();
                $this.getCargaTrabalhoResponsavel();
                $this.getIndiceRetrabalhoArtefato();
                $this.getTempoMedioCiclo();
            },

            getTotalProcessosAtivos() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetTotalProcessos`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.lstProcessos = result;
                            $this.kpiData.totalProcessos = (result == null ? 0 : result.length);
                            $this.kpiData.totalProcessosAtivos = (result.filter(x => x.flFinalizado == null || x.flFinalizado == false) == null ? 0 : result.filter(x => x.flFinalizado == null || x.flFinalizado == false).length);
                            $this.kpiData.totalProcessosFinalizados = (result.filter(x => x.flFinalizado == true) == null ? 0 : result.filter(x => x.flFinalizado == true).length);
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getProcessosAtrasados() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetProcessosAtrasados`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            if (result) {
                                $this.lstProcessosAtrasados = result;
                                $this.kpiData.processosAtrasados = (result == null ? 0 : result.length);
                            }
                            

                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getTempoMedioCicloTotal() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetTempoMedioCicloTotal`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.kpiData.tempoMedioCiclo = result;
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getTaxaCumprimentoPrazo() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetTaxaCumprimentoPrazo`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            $this.gaugeChartData = {
                                labels: ['Cumprido', 'Não Cumprido'],
                                percentual: result.nrPercentual,
                                datasets: [{
                                    data: [result.qtdCumprido, result.qtdNaoCumprido],
                                    backgroundColor: ['#10b981', '#e5e7eb'],
                                    borderWidth: 0
                                }]
                            };
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getDistribuicaoPorStatusProcesso() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetDistribuicaoPorStatus`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;

                            let dados = [];
                            if (result?.lstTaxaCumprimentoPrazo) {
                                for (let i = 0; i < result.lstTaxaCumprimentoPrazo.length; i++) {
                                    let item = result.lstTaxaCumprimentoPrazo[i];
                                    dados.push({
                                        nome: result.lstProcessoArtefatoTipoStatusHistorico.find(x => x.idTipoStatusHistorico == item.idTipoStatusHistorico).nmTipoStatusHistorico,
                                        qtdTotal: item.qtdTotal,
                                    })
                                }
                            }
                            
                            
                            $this.donutChartData = {
                                labels: dados.map(x=>x.nome),
                                    datasets: [{
                                        data: dados.map(x => x.qtdTotal),
                                        backgroundColor: [
                                            '#3b82f6',
                                            '#f59e0b',
                                            '#8b5cf6',
                                            '#ec4899',
                                            '#10b981'
                                        ],
                                        borderWidth: 2,
                                        borderColor: '#ffffff'
                                    }]
                            };
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getProcessosCriticos() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetProcessosCriticos`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;

                            let dados = [];
                            /*
                            processosCriticos: [
                                { id: 1, nome: 'Processo de Licitação 2024/001', etapaAtual: 'Elaboração', status: 'Atrasado', responsavel: 'João Silva', diasAtraso: 5 },
                                { id: 2, nome: 'Contrato de Serviços TI', etapaAtual: 'Revisão', status: 'Em Risco', responsavel: 'Maria Santos', diasAtraso: 0 },
                                { id: 3, nome: 'Aquisição de Equipamentos', etapaAtual: 'Aprovação', status: 'Atrasado', responsavel: 'Pedro Costa', diasAtraso: 8 },
                                { id: 4, nome: 'Processo de Compras 2024/045', etapaAtual: 'Elaboração', status: 'Em Risco', responsavel: 'Ana Oliveira', diasAtraso: 0 },
                                { id: 5, nome: 'Contrato de Manutenção', etapaAtual: 'Assinatura', status: 'Atrasado', responsavel: 'Carlos Mendes', diasAtraso: 3 }
                            ],
                            */
                            if (result) {
                                for (let i = 0; i < result.length; i++) {
                                    let item = result[i];
                                    dados.push({
                                        id: item.dados.idProcesso,
                                        nome: item.dados.dsNomeProcesso,
                                        nmModelo: item.dados.nmModelo,
                                        etapaAtual: item.dados.nmTipoStatusHistorico,
                                        status: (item.dados.diasAtraso > 0 ? 'Atrasado' : 'Em Risco'),
                                        responsavel: (item.usuario ? item.usuario.nmUsuario : '-'),
                                        diasAtraso: (item.dados.diasAtraso > 0 ? item.dados.diasAtraso : '-'),
                                    })
                                }
                            }
                            

                            $this.processosCriticos = dados;
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getRiscoEtapa() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetRiscoEtapa`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;

                            let etapas = [];
                            //riscoEtapaChartData: {
                            //    labels: ['Elaboração', 'Revisão', 'Aprovação', 'Assinatura', 'Publicação'],
                            //        datasets: [
                            //            {
                            //                label: 'No Prazo',
                            //                data: [25, 18, 12, 8, 5],
                            //                backgroundColor: '#10b981'
                            //            },
                            //            {
                            //                label: 'Em Risco',
                            //                data: [12, 8, 4, 3, 2],
                            //                backgroundColor: '#f59e0b'
                            //            },
                            //            {
                            //                label: 'Atrasado',
                            //                data: [8, 2, 2, 1, 0],
                            //                backgroundColor: '#ef4444'
                            //            }
                            //        ]
                            //},

                            etapas = result.map(x => x.nmEtapa)
                            // distinct
                            etapas = [...new Set(etapas)]

                            if (etapas == null) {
                                etapas = []
                            }

                            let lstNoPrazo = [];
                            let lstEmRisco = [];
                            let lstAtrasado = [];
                            for (let i = 0; i < etapas.length; i++) {
                                let etapa = etapas[i];
                                let qtdNoPrazo = result.find(x => x.nmEtapa == etapa && x.dsStatusEtapa == 'No Prazo')?.qtdProcessos;
                                let qtdEmRisco = result.find(x => x.nmEtapa == etapa && x.dsStatusEtapa == 'Em Risco')?.qtdProcessos;
                                let qtdAtrasado = result.find(x => x.nmEtapa == etapa && x.dsStatusEtapa == 'Atrasado')?.qtdProcessos;

                                lstNoPrazo.push((qtdNoPrazo ? qtdNoPrazo: 0));
                                lstEmRisco.push((qtdEmRisco ? qtdEmRisco: 0));
                                lstAtrasado.push((qtdAtrasado ? qtdAtrasado: 0));
                            }

                            $this.riscoEtapaChartData = {
                                labels: etapas,
                                datasets: [
                                    {
                                        label: 'No Prazo',
                                        data: lstNoPrazo,
                                        backgroundColor: '#10b981'
                                    },
                                    {
                                        label: 'Em Risco',
                                        data: lstEmRisco,
                                        backgroundColor: '#f59e0b'
                                    },
                                    {
                                        label: 'Atrasado',
                                        data: lstAtrasado,
                                        backgroundColor: '#ef4444'
                                    }
                                ]
                            };
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getTempoMedioEtapa() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetTempoMedioEtapa`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            let etapas = [];

                            //tempoMedioEtapaChartData: {
                            //    labels: ['Elaboração', 'Revisão', 'Aprovação', 'Assinatura', 'Publicação'],
                            //        datasets: [{
                            //            label: 'Tempo Médio (dias)',
                            //            data: [12, 5, 3, 2, 1],
                            //            backgroundColor: '#3b82f6'
                            //        }]
                            //},

                            etapas = result.map(x => x.nmEtapa)
                            $this.tempoMedioEtapaChartData = {
                                labels: etapas,
                                datasets: [
                                    {
                                        label: 'Tempo Médio (dias)',
                                        data: result.map(x => parseFloat(x.tempoMedioDias.toFixed(2))),
                                        backgroundColor: '#3b82f6'
                                    }
                                ]
                            };
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getCargaTrabalhoResponsavel() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetCargaTrabalhoResponsavel`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            let responsavel = [];

                            //cargaTrabalhoChartData: {
                            //    labels: ['João Silva', 'Maria Santos', 'Pedro Costa', 'Ana Oliveira', 'Carlos Mendes'],
                            //        datasets: [
                            //            {
                            //                label: 'No Prazo',
                            //                data: [8, 12, 6, 10, 7],
                            //                backgroundColor: '#10b981'
                            //            },
                            //            {
                            //                label: 'Atrasado',
                            //                data: [3, 2, 4, 1, 2],
                            //                backgroundColor: '#ef4444'
                            //            }
                            //        ]
                            //},

                            responsavel = result.map(x => x.usuario.nmUsuario);
                            
                            $this.cargaTrabalhoChartData = {
                                labels: responsavel,
                                datasets: [
                                    {
                                        label: 'No Prazo',
                                        data: result.map(x => x.dados.qtdNoPrazo),
                                        backgroundColor: '#10b981'
                                    },
                                    {
                                        label: 'Atrasado',
                                        data: result.map(x => x.dados.qtdAtrasados),
                                        backgroundColor: '#ef4444'
                                    }
                                ]
                            };
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getIndiceRetrabalhoArtefato() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetIndiceRetrabalhoArtefato`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            let modeloArtefato = [];

                            //retrabalhoChartData: {
                            //    labels: ['Termo de Referência', 'Edital', 'Matriz de Riscos', 'Plano de Trabalho', 'Relatório Técnico'],
                            //        datasets: [{
                            //            label: 'Índice de Retrabalho (%)',
                            //            data: [15, 22, 8, 12, 18],
                            //            backgroundColor: '#8b5cf6'
                            //        }]
                            //},

                            modeloArtefato = result.filter(x => x.nrTotalRetrabalhos > 0).map(x => x.nmModeloArtefato);
                            $this.retrabalhoChartData = {
                                labels: modeloArtefato,
                                datasets: [{
                                        label: 'Índice de Retrabalho (%)',
                                        data: result.filter(x => x.nrTotalRetrabalhos > 0).map(x => x.nrMediaRetrabalhos),
                                        backgroundColor: '#8b5cf6' 
                                    }
                                ]
                            };
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            getTempoMedioCiclo() {
                let $this = this;
                axios.get(`${urlApi}/DashboardProcesso/GetTempoMedioCiclo`, {
                    params: {
                        //index: $this.currentPage,
                        //take: $this.pageSize,
                    }
                })
                    .then(res => {
                        if (res.data.success) {
                            const result = res.data.data;
                            let meses = [];

                            //tmcTendenciaChartData: {
                            //    labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                            //        datasets: [{
                            //            label: 'Tempo Médio de Ciclo (dias)',
                            //            data: [28, 26, 25, 24, 23, 22, 23, 24, 23, 22, 23, 23],
                            //            borderColor: '#3b82f6',
                            //            backgroundColor: 'rgba(59, 130, 246, 0.1)',
                            //            fill: true,
                            //            tension: 0.4,
                            //            pointRadius: 5,
                            //            pointHoverRadius: 7
                            //        }]
                            //},
                            meses = result.map(x => x.nmMes);
                            $this.tmcTendenciaChartData = {
                                labels: meses,
                                datasets: [{
                                    label: 'Tempo Médio de Ciclo (dias)',
                                    data: result.map(x => x.tempoMedioDias),
                                    borderColor: '#3b82f6',
                                    backgroundColor: 'rgba(59, 130, 246, 0.1)',
                                    fill: true,
                                    tension: 0.4,
                                    pointRadius: 5,
                                    pointHoverRadius: 7
                                }]
                            };
                        } else {
                            avisoToast("Erro ao carregar dashboard!", "warning");
                        }
                    })
                    .catch(() => {
                        avisoToast("Erro ao carregar dashboard!", "warning");
                    });
            },

            // POPOVERS
            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });

                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    customClass: 'custom-popover'
                                    //placement: "right",
                                });
                            });
                    }
                });
            },
            
            getDataBsTMC() {
                let html = '<span class="mb-0">Tempo médio do <strong>Iníco</strong> ao <strong>Fim</strong> do Processo</span>';
                return html;
            },


            abreModalProcessos() {
                this.bsModalProcessosAtivos?.show?.()
            },

            abreModalProcessosAtrasados() {
                this.ModalProcessosAtrasados?.show?.()
            }
        },
        mounted: function () {
            this.load()

            const el = document.getElementById('ModalProcessosAtivos')
            const bs = window.bootstrap || window.Bootstrap
            if (el && bs?.Modal) {
                this.bsModalProcessosAtivos = new bs.Modal(el)
            }

            const elModalProcessosAtrasados = document.getElementById('ModalProcessosAtrasados')
            if (elModalProcessosAtrasados && bs?.Modal) {
                this.ModalProcessosAtrasados = new bs.Modal(elModalProcessosAtrasados)
            }
        }
    }
</script>

<style lang="scss" scoped>
    /* Header Moderno */
    .modern-header {
        background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
        padding: 12px 0;
        border-bottom: 1px solid #e5e7eb;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.02);
    }

    [data-bs-theme="dark"] .modern-header {
        background: linear-gradient(135deg, #1f2937 0%, #111827 100%);
        border-bottom-color: #374151;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 20px;
    }

    .title-section {
        flex: 1;
    }

    .modern-title {
        font-size: 32px;
        font-weight: 800;
        color: #1f2937;
        margin-bottom: 6px;
        letter-spacing: -0.5px;
        line-height: 1.2;
    }

    [data-bs-theme="dark"] .modern-title {
        color: #f9fafb;
    }

    .modern-subtitle {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin: 0;
    }

    [data-bs-theme="dark"] .modern-subtitle {
        color: #9ca3af;
    }

    /* Dashboard Container */
    .dashboard-container {
        padding: 32px 16px;
        background: #f9fafb;
    }

    [data-bs-theme="dark"] .dashboard-container {
        background: #111827;
    }

    .dashboard-section {
        margin-bottom: 20px;
    }

    .section-title {
        font-size: 24px;
        font-weight: 700;
        color: #1f2937;
        margin-bottom: 24px;
        padding-bottom: 12px;
        border-bottom: 2px solid #e5e7eb;
    }

    [data-bs-theme="dark"] .section-title {
        color: #f9fafb;
        border-bottom-color: #374151;
    }

    /* KPI Cards */
    .kpi-cards-grid {
        display: flex;
        flex-direction: column;
        /*grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));*/
        gap: 24px;
        /*margin-bottom: 32px;*/
    }

    .kpi-card {
        background: white;
        border-radius: 16px;
        padding: 24px;
        display: flex;
        align-items: center;
        gap: 20px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .kpi-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    }

    .kpi-card-alert {
        border-left: 4px solid #ef4444;
    }

    [data-bs-theme="dark"] .kpi-card {
        background: #1f2937;
    }

    .kpi-icon {
        width: 50px;
        height: 50px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 22px;
        flex-shrink: 0;
    }

    .kpi-content {
        flex: 1;
    }

    .kpi-label {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
        margin-bottom: 8px;
    }

    [data-bs-theme="dark"] .kpi-label {
        color: #9ca3af;
    }

    .kpi-value {
        font-size: 22px;
        font-weight: 700;
        color: #1f2937;
        line-height: 1;
    }

    [data-bs-theme="dark"] .kpi-value {
        color: #f9fafb;
    }

    /* Chart Containers */
    .chart-container {
        /*margin-top: 24px;*/
    }

    .charts-grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(500px, 1fr));
        gap: 24px;
        margin-bottom: 24px;
    }

    .chart-card {
        background: white;
        border-radius: 16px;
        padding: 24px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    [data-bs-theme="dark"] .chart-card {
        background: #1f2937;
    }

    .chart-title {
        font-size: 18px;
        font-weight: 600;
        color: #1f2937;
        margin-bottom: 20px;
    }

    [data-bs-theme="dark"] .chart-title {
        color: #f9fafb;
    }

    .gauge-chart-wrapper {
        height: 250px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .donut-chart-wrapper {
        height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    .gauge-value {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
        pointer-events: none;
    }

    .gauge-value-number {
        font-size: 36px;
        font-weight: 700;
        color: #10b981;
        line-height: 1;
        margin-bottom: 4px;
    }

    [data-bs-theme="dark"] .gauge-value-number {
        color: #34d399;
    }

    .gauge-value-label {
        font-size: 14px;
        color: #6b7280;
        font-weight: 500;
    }

    [data-bs-theme="dark"] .gauge-value-label {
        color: #9ca3af;
    }

    /* Tabela de Processos Críticos */
    .table-responsive {
        overflow-x: auto;
    }
    .table-responsive-processos-criticos {
        max-height: 50vh;
        overflow: auto;
    }
    .processos-criticos-table {
        width: 100%;
        border-collapse: collapse;
    }

    .processos-criticos-table thead {
        background: #f9fafb;
    }

    [data-bs-theme="dark"] .processos-criticos-table thead {
        background: #374151;
    }

    .processos-criticos-table th {
        padding: 12px 16px;
        text-align: left;
        font-weight: 600;
        font-size: 13px;
        color: #374151;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        border-bottom: 2px solid #e5e7eb;
    }

    [data-bs-theme="dark"] .processos-criticos-table th {
        color: #e5e7eb;
        border-bottom-color: #4b5563;
    }

    .processos-criticos-table td {
        padding: 14px 16px;
        border-bottom: 1px solid #f3f4f6;
        color: #374151;
        font-size: 14px;
    }

    [data-bs-theme="dark"] .processos-criticos-table td {
        color: #e5e7eb;
        border-bottom-color: #374151;
    }

    .processos-criticos-table tbody tr:hover {
        background: #f9fafb;
    }

    [data-bs-theme="dark"] .processos-criticos-table tbody tr:hover {
        background: #374151;
    }

    .dias-atraso {
        color: #ef4444;
        font-weight: 600;
    }

    /* Status Badges */
    .status-badge {
        display: inline-flex;
        align-items: center;
        padding: .25rem .6rem;
        border-radius: 999px;
        font-weight: 600;
        font-size: .75rem;
        line-height: 1;
        border: 1px solid transparent;
    }

    .status-badge--ativo {
        background: rgba(16, 185, 129, .12);
        color: #059669;
        border-color: rgba(16, 185, 129, .25);
    }

    .status-badge--inativo {
        background: rgba(239, 68, 68, .12);
        color: #dc2626;
        border-color: rgba(239, 68, 68, .25);
    }

    .status-badge--risco {
        background: rgba(245, 158, 11, .12);
        color: #d97706;
        border-color: rgba(245, 158, 11, .25);
    }

    /* Responsive */
    @media (max-width: 768px) {
        .kpi-cards-grid {
            grid-template-columns: 1fr;
        }

        .charts-grid {
            grid-template-columns: 1fr;
        }

        .modern-title {
            font-size: 28px;
        }

        .modern-subtitle {
            font-size: 13px;
        }

        .dashboard-container {
            padding: 24px 12px;
        }

        .section-title {
            font-size: 20px;
        }

        .processos-criticos-table {
            font-size: 12px;
        }

        .processos-criticos-table th,
        .processos-criticos-table td {
            padding: 10px 12px;
        }
    }

    /* Popover Custom Styling */
    .custom-popover {
        border-radius: 12px;
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
        border: 2px solid rgba(31, 123, 255, 0.2);
        .popover-header

    {
        background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
        color: white;
        border-radius: 10px 10px 0 0;
        font-weight: 600;
    }

    .popover-body {
        font-size: 0.9rem;
        line-height: 1.6;
    }

    }

    /* Estado Vazio */
    .empty-state {
        padding: 40px 20px !important;
        background: linear-gradient(to bottom, #fafafa 0%, #ffffff 100%);
    }

    [data-bs-theme="dark"] .empty-state {
        background: linear-gradient(to bottom, #1f2937 0%, #111827 100%);
    }

    .empty-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        animation: fadeInUp 0.5s ease-out;
    }

/* modal */
    .modern-modal .modal-modern-content {
        border-radius: 20px;
        background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
        box-shadow: 0 20px 60px rgba(15, 23, 42, 0.18);
        position: relative;
    }

    .modal-modern-header {
        display: flex;
        align-items: flex-start;
        gap: 18px;
        padding: 32px 32px 20px;
        position: relative;
    }

    .modal-modern-header::after {
        content: '';
        position: absolute;
        bottom: -1px;
        left: 32px;
        right: 32px;
        height: 1px;
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.35), transparent);
    }

    .modal-modern-header .header-icon {
        width: 64px;
        height: 64px;
        border-radius: 18px;
        display: flex;
        align-items: center;
        justify-content: center;
        /*background: linear-gradient(135deg, rgba(37, 99, 235, 0.12) 0%, rgba(16, 185, 129, 0.12) 100%);*/
        color: #2563eb;
    }

    .modal-modern-header .header-text h2 {
        margin: 0;
        font-size: 24px;
        font-weight: 700;
        color: #0f172a;
    }

    .modal-modern-header .header-text p {
        margin-top: 6px;
        margin-bottom: 0;
        color: #475569;
        font-size: 14px;
        max-width: 420px;
        line-height: 1.4;
    }

    .modal-modern-body {
        padding: 28px 32px;
        display: flex;
        flex-direction: column;
        gap: 20px;
    }
    .modal-modern-footer {
        padding: 0 32px 32px;
    }

    .btn-close-modern {
        position: absolute;
        top: 18px;
        right: 18px;
        width: 44px;
        height: 44px;
        border-radius: 50% !important;
        background: #ffffff !important;
        border: 2px solid rgba(148, 163, 184, 0.25) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0 10px 30px rgba(15, 23, 42, 0.12);
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }

    .btn-close-modern svg {
        color: #334155;
    }

    .btn-close-modern:hover {
        transform: scale(1.07);
        box-shadow: 0 14px 34px rgba(37, 99, 235, 0.2);
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
        border-color: transparent !important;
    }

    .btn-close-modern:hover svg {
        color: #ffffff;
    }
    @media (max-width: 768px) {
        .modal-modern-header,
        .modal-modern-body,
        .modal-modern-footer {
            padding: 24px 20px;
        }

        .modal-modern-header {
            flex-direction: column;
            align-items: stretch;
            gap: 14px;
        }

        .modal-modern-header::after {
            left: 20px;
            right: 20px;
        }

        .modal-modern-header .header-icon {
            width: 56px;
            height: 56px;
        }

        .form-group-inline {
            flex-direction: column;
            align-items: stretch;
        }
    }

    @media (max-width: 576px) {
        .modern-modal .modal-dialog {
            margin: 12px;
        }

        .modal-modern-header .header-text h2 {
            font-size: 22px;
        }

        .modal-modern-header .header-text p {
            font-size: 13px;
        }
    }

    [data-bs-theme="dark"] .modern-modal .modal-modern-content {
        background: linear-gradient(135deg, #0f172a 0%, #111826 100%);
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.55);
    }

    [data-bs-theme="dark"] .modal-modern-header .header-icon {
        background: linear-gradient(135deg, rgba(59, 130, 246, 0.18) 0%, rgba(45, 212, 191, 0.18) 100%);
        color: #60a5fa;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text h2 {
        color: #f8fafc;
    }

    [data-bs-theme="dark"] .modal-modern-header .header-text p {
        color: #94a3b8;
    }


    [data-bs-theme="dark"] .modal-modern-body {
        background: transparent;
    }

    [data-bs-theme="dark"] .modern-modal .form-control {
        background: rgba(15, 23, 42, 0.8);
        border-color: rgba(148, 163, 184, 0.2);
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modern-modal .form-control:focus {
        background: rgba(15, 23, 42, 0.95);
    }

    [data-bs-theme="dark"] .modern-modal select.form-control {
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='9' viewBox='0 0 14 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1.5L7 7.5L13 1.5' stroke='%2394A3B8' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    }

    [data-bs-theme="dark"] .modern-modal .form-label {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .modal-modern-header::after {
        background: linear-gradient(90deg, transparent, rgba(148, 163, 184, 0.25), transparent);
    }

    [data-bs-theme="dark"] .modal-modern-footer {
        background: transparent;
    }

    [data-bs-theme="dark"] .form-group-inline .info-chip {
        background: rgba(37, 99, 235, 0.15);
        color: #cbd5f5;
    }

    [data-bs-theme="dark"] .modern-modal small.text-muted {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .btn-close-modern {
        background: rgba(15, 23, 42, 0.9) !important;
        border-color: rgba(148, 163, 184, 0.25) !important;
    }

    [data-bs-theme="dark"] .btn-close-modern svg {
        color: #e2e8f0;
    }

    [data-bs-theme="dark"] .btn-close-modern:hover {
        background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
    }

    [data-bs-theme="dark"] .btn-modern-primary {
        background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);
        box-shadow: 0 12px 28px rgba(37, 99, 235, 0.45);
    }

    [data-bs-theme="dark"] .modern-modal .form-control::placeholder {
        color: #64748b;
    }
    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 12px 22px;
        border-radius: 14px;
        font-weight: 600;
        font-size: 14px;
        letter-spacing: 0.3px;
        text-transform: uppercase;
        border: none;
        cursor: pointer;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
        box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
        color: #ffffff;
    }

    .modern-btn:hover {
        transform: translateY(-2px);
    }

    .modern-btn:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        transform: none;
    }

    .modern-btn-secondary {
        background: linear-gradient(135deg, #94a3b8 0%, #64748b 100%);
    }

    .modern-btn-success {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    }
</style>
